import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, useMediaQuery } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useEffect } from 'react';

const Notes: React.FunctionComponent<any> = ({ notes, handleNotes }) => {
  const isMobileScreen: boolean = useMediaQuery('(max-width:600px)');
  const isMaxScreen = useMediaQuery('(min-width:1920px)');

  // Add CSS override for app-textArea to fix color issue
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      #app-textArea {
        color: #333333 !important;
        font-size: 14px !important;
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <Box component={'div'} padding={isMobileScreen ? '0px' : isMaxScreen ? '0px 30px' : '0px 20px'}>
      {isMobileScreen ? (
        <textarea
          value={notes}
          onChange={(e) => {
            handleNotes(e.target.value);
          }}
          placeholder="Enter your notes here..."
          style={{ height: '350px', width: '100%', resize: 'none', background: '#FCFCFC', borderRadius: '8px', border: 'none', color: '#333333', fontSize: '14px' }}
        />
      ) : (
        <Grid container spacing={4}>
          <Grid item lg={2}>
            <Accordion sx={{ boxShadow: 'none' }}>
              <AccordionSummary
                expandIcon={<KeyboardArrowUpIcon sx={{ height: '16px' }} />}
                sx={{
                  borderBottom: '1px solid #E3E3E3',
                  '& .MuiAccordionSummary-content': {
                    margin: '0px',
                  },
                  '& .Mui-expanded': {
                    margin: '0px',
                  },
                }}
              >
                <Typography fontSize={isMaxScreen ? '16px' : '12px'} fontWeight={'500'} margin={'0px 0px'} color={'#000000'}>
                  Notes
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ padding: '15px 10px' }}>
                <Box sx={{ border: '1px solid #0000001A', height: '210px', borderRadius: '8px' }} />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item lg={10}>
            <Box component={'div'} padding={'0px 24px'} height={isMaxScreen ? '450px' : '350px'} overflow={'auto'}>
              <textarea
                value={notes}
                onChange={(e) => {
                  handleNotes(e.target.value);
                }}
                placeholder="Enter your notes here..."
                style={{ height: '1500px', width: '100%', resize: 'none', background: '#FCFCFC', borderRadius: '8px', border: 'none', padding: '30px', color: '#333333', fontSize: '14px' }}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default Notes;
